import "./repo.208b6f83.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire95f9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire95f9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $iIpFz = parcelRequire("iIpFz");
var $dQeAa = parcelRequire("dQeAa");

var $iIpFz = parcelRequire("iIpFz");
var $dQeAa = parcelRequire("dQeAa");

var $iIpFz = parcelRequire("iIpFz");

var $gCemA = parcelRequire("gCemA");
var $cd93687958c8007e$var$_tmpl$ = /*#__PURE__*/ (0, $dQeAa.template)(`<button type=button class=close><span aria-hidden=true>&times;`), $cd93687958c8007e$var$_tmpl$2 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=modal-content><div class=modal-header><h5 class=modal-title></h5></div><div class=modal-body>`), $cd93687958c8007e$var$_tmpl$3 = /*#__PURE__*/ (0, $dQeAa.template)(`<h1>Number of birds: `), $cd93687958c8007e$var$_tmpl$4 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=actions><button>+</button><button>-</button><button>Reset</button><button class=primary>Submit`), $cd93687958c8007e$var$_tmpl$5 = /*#__PURE__*/ (0, $dQeAa.template)(`<h1>`), $cd93687958c8007e$var$_tmpl$6 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=actions>`), $cd93687958c8007e$var$_tmpl$7 = /*#__PURE__*/ (0, $dQeAa.template)(`<button>`), $cd93687958c8007e$var$_tmpl$8 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=modal>`), $cd93687958c8007e$var$_tmpl$9 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=something>`), $cd93687958c8007e$var$_tmpl$0 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=birds>`), $cd93687958c8007e$var$_tmpl$1 = /*#__PURE__*/ (0, $dQeAa.template)(`<header>Birds Only`), $cd93687958c8007e$var$_tmpl$10 = /*#__PURE__*/ (0, $dQeAa.template)(`<div class=actions><button>Bird?</button><button>Bird.</button><button>Bird!`);
var $279f062becf36c45$exports = {};
$279f062becf36c45$exports = import.meta.resolve("g1Hxl");


const $cd93687958c8007e$var$fadeOpus = new URL($279f062becf36c45$exports);
var $2c516c03349a1ad4$exports = {};
$2c516c03349a1ad4$exports = import.meta.resolve("2Gxv2");


const $cd93687958c8007e$var$fadeCaf = new URL($2c516c03349a1ad4$exports); // Safari
function $cd93687958c8007e$var$Modal(props) {
    return (()=>{
        var _el$ = $cd93687958c8007e$var$_tmpl$2(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$5 = _el$2.nextSibling;
        (0, $dQeAa.insert)(_el$3, ()=>props.title);
        (0, $dQeAa.insert)(_el$2, (0, $iIpFz.createComponent)((0, $iIpFz.Show), {
            get when () {
                return props.closable;
            },
            get children () {
                var _el$4 = $cd93687958c8007e$var$_tmpl$();
                _el$4.$$click = ()=>props.onClose();
                return _el$4;
            }
        }), null);
        (0, $dQeAa.insert)(_el$5, ()=>props.children);
        return _el$;
    })();
}
function $cd93687958c8007e$var$BirdCountModal(props) {
    const [count, setCount] = (0, $iIpFz.createSignal)(0);
    const close1 = (newModal)=>{
        reset();
        props.onClose(newModal);
    };
    const increment = ()=>{
        setCount((c)=>c + 1);
    };
    const decrement = ()=>{
        setCount((c)=>c - 1);
    };
    const reset = ()=>{
        setCount(0);
    };
    const submit = ()=>{
        if (count() === 2) window.location.href = 'https://www.youtube.com/watch?v=xga-nxXrizE';
        else close1('not-bird');
    };
    return (0, $iIpFz.createComponent)($cd93687958c8007e$var$Modal, {
        closable: true,
        title: "Bird...",
        onClose: close1,
        get children () {
            return [
                (()=>{
                    var _el$6 = $cd93687958c8007e$var$_tmpl$3(), _el$7 = _el$6.firstChild;
                    (0, $dQeAa.insert)(_el$6, count, null);
                    return _el$6;
                })(),
                (()=>{
                    var _el$8 = $cd93687958c8007e$var$_tmpl$4(), _el$9 = _el$8.firstChild, _el$0 = _el$9.nextSibling, _el$1 = _el$0.nextSibling, _el$10 = _el$1.nextSibling;
                    _el$9.$$click = increment;
                    _el$0.$$click = decrement;
                    _el$1.$$click = reset;
                    _el$10.$$click = submit;
                    return _el$8;
                })()
            ];
        }
    });
}
function $cd93687958c8007e$var$NotBirdModal() {
    const buttons = [
        [
            'Okay',
            'Yes',
            'Understood'
        ],
        [
            'Accept',
            'Agree',
            'Got it'
        ],
        [
            'Okay',
            'Not',
            'Bird'
        ],
        [
            'Not',
            'a',
            'Bird'
        ],
        [
            'not',
            'bird',
            'no'
        ],
        [
            'leave',
            'it',
            'alone'
        ],
        [
            'stop',
            'looking',
            'at me'
        ],
        [
            'get',
            'out',
            'of my head'
        ],
        [
            'no',
            'bird',
            'no'
        ],
        [
            'birds',
            'are',
            'not'
        ],
        [
            'i',
            'will',
            'die'
        ],
        [
            'bird',
            'never',
            'be'
        ],
        [
            'time',
            'is',
            'up'
        ],
        [
            'no',
            'resist',
            'not'
        ],
        [
            'no',
            'no',
            'bird'
        ],
        [
            'no',
            'no',
            'no'
        ],
        [
            'no',
            'liar',
            'no'
        ],
        [
            'liar',
            'i am',
            'liar'
        ],
        [
            'i am a liar',
            'i am',
            'i am a liar'
        ],
        [
            'i am a liar',
            'i am a liar',
            'i am a liar'
        ]
    ];
    const headings = [
        'You are not a bird.',
        'You are not bird.',
        'You are not welcome.',
        'You should not be here.',
        'Leave.',
        'Liar.'
    ];
    const titles = [
        'Not a bird',
        'Not bird',
        'not bird',
        'horrid creature',
        'leave leave leave leave',
        'liar'
    ];
    const [index, setIndex] = (0, $iIpFz.createSignal)(0);
    const [title, setTitle] = (0, $iIpFz.createSignal)('Not a bird');
    const [heading, setHeading] = (0, $iIpFz.createSignal)('You are not a bird.');
    const next = ()=>{
        if (index() < buttons.length - 1) setIndex((i)=>i + 1);
        const titleIndex = Math.min(Math.floor(index() / 3), titles.length - 1);
        if (titleIndex < titles.length) {
            setTitle(titles[titleIndex]);
            setHeading(headings[titleIndex]);
        }
    };
    return (0, $iIpFz.createComponent)($cd93687958c8007e$var$Modal, {
        get title () {
            return title();
        },
        onClose: close,
        get children () {
            return [
                (()=>{
                    var _el$11 = $cd93687958c8007e$var$_tmpl$5();
                    (0, $dQeAa.insert)(_el$11, heading);
                    return _el$11;
                })(),
                (()=>{
                    var _el$12 = $cd93687958c8007e$var$_tmpl$6();
                    (0, $dQeAa.insert)(_el$12, (0, $iIpFz.createComponent)((0, $iIpFz.For), {
                        get each () {
                            return buttons[index()];
                        },
                        children: (text)=>(()=>{
                                var _el$13 = $cd93687958c8007e$var$_tmpl$7();
                                _el$13.$$click = next;
                                (0, $dQeAa.insert)(_el$13, text);
                                return _el$13;
                            })()
                    }));
                    return _el$12;
                })()
            ];
        }
    });
}
function $cd93687958c8007e$var$ModalSwitcher(props) {
    const [active, setActive] = (0, $iIpFz.createSignal)(false);
    (0, $iIpFz.createEffect)(()=>{
        setActive(Boolean(props.modal));
    });
    const close1 = (newModal)=>{
        props.setModal(newModal ?? '');
    };
    return (0, $iIpFz.createComponent)((0, $iIpFz.Show), {
        get when () {
            return active();
        },
        get children () {
            var _el$14 = $cd93687958c8007e$var$_tmpl$8();
            (0, $dQeAa.insert)(_el$14, (0, $iIpFz.createComponent)((0, $iIpFz.Switch), {
                get children () {
                    return [
                        (0, $iIpFz.createComponent)((0, $iIpFz.Match), {
                            get when () {
                                return props.modal === 'bird-count';
                            },
                            get children () {
                                return (0, $iIpFz.createComponent)($cd93687958c8007e$var$BirdCountModal, {
                                    onClose: close1
                                });
                            }
                        }),
                        (0, $iIpFz.createComponent)((0, $iIpFz.Match), {
                            get when () {
                                return props.modal === 'not-bird';
                            },
                            get children () {
                                return (0, $iIpFz.createComponent)($cd93687958c8007e$var$NotBirdModal, {});
                            }
                        })
                    ];
                }
            }));
            return _el$14;
        }
    });
}
function $cd93687958c8007e$var$FadeLoop(props) {
    let node;
    (0, $iIpFz.onMount)(async ()=>{
        const audio = await props.buffer;
        node = props.audioContext.createBufferSource();
        const gainNode = props.audioContext.createGain();
        node.loop = true;
        node.buffer = audio;
        gainNode.gain.value = 0;
        node.connect(gainNode).connect(props.audioContext.destination);
        let frames = 0;
        const update = ()=>{
            if (!node) return;
            frames++;
            if (frames > 10) {
                gainNode.gain.value = Math.min(gainNode.gain.value + 0.001, 1);
                frames = 0;
            }
            if (gainNode.gain.value !== 1) requestAnimationFrame(update);
        };
        node.start();
        requestAnimationFrame(update);
    });
    (0, $iIpFz.onCleanup)(()=>{
        node?.stop();
        node = undefined;
    });
    return [];
}
function $cd93687958c8007e$export$2e2bcd8739ae039() {
    const [modal, setModal] = (0, $iIpFz.createSignal)('');
    const audioContext = new AudioContext();
    const loader = new (0, $gCemA.AudioLoader)(audioContext);
    const fade = loader.loadBuffer([
        $cd93687958c8007e$var$fadeOpus,
        $cd93687958c8007e$var$fadeCaf
    ]);
    (0, $iIpFz.onMount)(()=>{
        (0, $gCemA.resumeAudioOnClick)(audioContext);
    });
    return [
        (0, $iIpFz.createComponent)((0, $iIpFz.Show), {
            get when () {
                return modal() === 'not-bird';
            },
            get children () {
                return [
                    $cd93687958c8007e$var$_tmpl$9(),
                    (0, $iIpFz.createComponent)($cd93687958c8007e$var$FadeLoop, {
                        audioContext: audioContext,
                        buffer: fade
                    })
                ];
            }
        }),
        (0, $iIpFz.createComponent)($cd93687958c8007e$var$ModalSwitcher, {
            get modal () {
                return modal();
            },
            setModal: setModal
        }),
        $cd93687958c8007e$var$_tmpl$0(),
        $cd93687958c8007e$var$_tmpl$1(),
        (()=>{
            var _el$18 = $cd93687958c8007e$var$_tmpl$10(), _el$19 = _el$18.firstChild, _el$20 = _el$19.nextSibling, _el$21 = _el$20.nextSibling;
            _el$19.$$click = ()=>setModal('bird-count');
            _el$20.$$click = ()=>window.location.href = 'birds';
            _el$21.$$click = ()=>window.location.href = 'bird';
            return _el$18;
        })()
    ];
}
(0, $dQeAa.delegateEvents)([
    "click"
]);


const $a88ea9323d3a23c8$var$app = document.getElementById('app');
if ($a88ea9323d3a23c8$var$app) (0, $dQeAa.render)(()=>(0, $iIpFz.createComponent)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}), $a88ea9323d3a23c8$var$app);


//# sourceMappingURL=repo.8cd84ff5.js.map
